import { Button, Clickable, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Bold = styled.span`
  color: #000;
  font-weight: 500;
`;

const NoUserFound = ({ email, setResetStep }) => {
  const navigate = useNavigate(),
    { t } = useTranslation();

  return (
    <Col noFlex centerAll wid="100%">
      <Row wid="132px" ht="132px" bg={theme.SECONDARY} hasRadius="132px" centerAll marg="48px 0 0">
        <Icon type="warningOutline" dimensions={58} col="#fff" />
      </Row>

      <Text h1 marg="32px 0 0" center>
        {t('forgotPassword.checkEmail')}
      </Text>

      <Text b1 marg="8px 0 0" col={theme.GREY_60} center>
        {t('forgotPassword.noAccount')} <Bold>{email}</Bold>
      </Text>

      <Text b1 col={theme.GREY_60} center>
        {t('forgotPassword.anotherAddress')}
      </Text>

      <Button
        marg="32px 0 0"
        wid="296px"
        app
        onClick={() => setResetStep('Email')}
        text={t('forgotPassword.tryAnother')}
      />

      <Clickable onClick={() => navigate('/login')} marg="27px 0 0">
        <Text b2 center bold>
          {t('forgotPassword.backToLogin')}
        </Text>
      </Clickable>
    </Col>
  );
};

export default NoUserFound;
